import { isEqual } from 'lodash';
import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import useVehicles from '../../../hooks/api-calls/useVehicles';
import { maintenanceTypes } from '../../../utils/SelectorMapping';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';


interface MaintenancesFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const MaintenanceFilters: React.FC<MaintenancesFiltersProps> = ({ filters, updateFilters }) => {
    // HOOKS

    const { getVehiclesList, vehiclesLoading } = useVehicles();
    const { getCompaniesList  } = useCompanies();
    const { userCan } = usePrivilege();


    // RENDER

    return (
        <>

            <CustomSelect
                isSearchable
                isClearable
                isLoading={vehiclesLoading}
                id={'vehicle_id'}
                label="Vehiculo"
                placeholder=' vehiculo'
                value={filters.filter_filters?.vehicle_id ? { value: filters.filter_filters?.vehicle_id, label: getVehiclesList()?.find((g: any) => g.value === filters.filter_filters?.vehicle_id)?.label } : null}
                options={getVehiclesList()}
                onChange={(value: any) => updateFilters({ vehicle_id: value?.value })}
            />

            <CustomSelect
                id="type"
                label="Tipo de mantenimiento"
                placeholder="Seleccionar tipo"
                options={maintenanceTypes}
                value={maintenanceTypes.filter((item: any) => filters.filter_filters?.type?.includes(item.value))}
                onChange={(value: any) => updateFilters({ type: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <DateField
                isClearable
                className="w-full"
                label="Rango de fechas"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "date"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Fecha de mantenimiento", value: "date" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="cost_min"
                    label="Coste mínimo"
                    placeholder="Ingrese coste mínimo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ cost_min: null })}
                    suffix="€"
                />

                <CustomTextDelayInput
                    id="cost_max"
                    label="Coste máximo"
                    placeholder="Ingrese coste máximo"
                    type="number"
                    step="0.01"
                    min="0"
                    filters={filters}
                    updateFilters={updateFilters}
                    isClearable={true}
                    onClear={() => updateFilters({ cost_max: null })}
                    suffix="€"
                />
            </div>

            <CustomTextDelayInput
                id="description"
                label="Descripción"
                placeholder="Buscar en descripción..."
                filters={filters}
                updateFilters={updateFilters}
                type="text"
            />

            {userCan('list', 'company') && (
            <CustomSelect
                id="company"
                label="Compañía"
                placeholder="Seleccionar compañía"
                options={getCompaniesList()}
                value={filters.filter_filters?.company ? { value: filters.filter_filters?.company, label: getCompaniesList()?.find((g: any) => g.value === filters.filter_filters?.company)?.label } : null}
                onChange={(value: any) => updateFilters({ company: value?.value })}
                isClearable={true}
            />
            )}
        </>
    );
};

export default MaintenanceFilters;